export const PersonInsuranceRequireModel = [
  {
    formName: 'formPersonInsurancePlan',
    fieldRequired: [
      'exploitingType',
      'businessProgramCode',
      'exploitingCode',
      'curencyMoney',
      'curencyFee',
      'exchangeRate',
      'business',
      'businessName',
      'calculationType',
      'amountPeople',
      'nationality',
    ],
  },
  {
    formName: 'formPersonInsurancePlanRetail',
    fieldRequired: [
      'exploitingType',
      'businessProgramCode',
      'exploitingCode',
      'curencyMoney',
      'curencyFee',
      'exchangeRate',
      'calculationType',
      'nationality',
    ],
  },
  {
    formName: 'formPersonOfferFee',
    fieldRequired: ['packageCode', 'name', 'startDate', 'expireDate'],
  },
  {
    formName: 'formPersonListUser',
    fieldRequired: [
      'customerName',
      'identificationNumber',
      'customerBirthDay',
      'objectInsuredType',
      'gender',
      'packageCode',
      'startDate',
      'expireDate',
      'relationsShip',
      'addressName',
    ],
  },
  {
    formName: 'formPersonContract',
    fieldRequired: ['contractType', 'manager', 'tsIncharge'],
  },
]
